import React, { useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import HubspotForm from 'react-hubspot-form'
import './AutoPopup.scss'
import { StaticImage } from 'gatsby-plugin-image'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocation } from '@reach/router'
import logo from '../../images/celerity-logo-black.svg'
const isAutoPopupActive = 'isAutoPopupActive'
const AutoPopup = () => {
    const data = useStaticQuery(graphql`
        query AutoPopupQuery {
            wp {
                siteSettings {
                    autoPopup {
                        active
                        portalId
                        formId
                        description
                        taxonomy {
                            slug
                        }
                    }
                }
            }
        }
    `)

    const [isOpen, setIsOpen] = useState(false)
    const { pathname } = useLocation()

    const category = pathname.split('/')[1]
    function closeModal() {
        setIsOpen(false)
    }

    useEffect(() => {
        const isVisited = sessionStorage.getItem(isAutoPopupActive)
        if (!isVisited) {
            const timeout = setTimeout(() => {
                setIsOpen(true)

                sessionStorage.setItem(isAutoPopupActive, true)
            }, 5000)

            return () => {
                clearTimeout(timeout)
            }
        }
    }, [])

    if (!data) {
        return null
    }

    const { active, description, formId, portalId, taxonomy } =
        data.wp?.siteSettings?.autoPopup || {}
    const slugs =
        taxonomy?.map((item) => {
            return item.slug
        }) || []

    if (!slugs.includes(category)) {
        return null
    }

    if (!active) {
        return null
    }

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[999] " onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full relative max-w-md lg:max-w-xl lg:py-10 transform overflow-hidden bg-white p-6 text-left align-middle shadow-xl transition-all">
                                {/* <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900"
                                >
                                    Payment successful
                                </Dialog.Title> */}
                                <div className="w-32 mb-3">
                                    <img
                                        src={logo}
                                        alt="Celerity logo"
                                        className="w-full object-contain"
                                        lazy
                                    />
                                </div>

                                {description && (
                                    <p
                                        className="text-lg mb-7"
                                        style={{ textWrap: 'balance' }}
                                    >
                                        {description}
                                    </p>
                                )}

                                <HubspotForm
                                    portalId={portalId}
                                    formId={formId}
                                    onFormSubmit={() => {
                                        window.dataLayer.push({
                                            event: 'news_submit_click',
                                            eventCategory: 'newsletter_form_submit'
                                        })
                                    }}
                                    onFormSubmitted={() => {
                                        window.dataLayer.push({
                                            event: 'news_submitted',
                                            eventCategory: 'newsletter_form_submit'
                                        })
                                    }}
                                    loading={<div>Loading...</div>}
                                    errorClass={'field_required'}
                                    cssClass={'auto-popup-hs-form'}
                                />

                                <button
                                    type="button"
                                    onClick={closeModal}
                                    className="w-8 absolute top-5 right-5 group"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-full group-hover:rotate-90 duration-300 transition-transform"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default AutoPopup
